import { useContext, useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

type DeleteConnfirmDialogProps = {
  open: boolean;
  onOk: () => void;
  onClose: () => void;
};

export const DeleteConfirmDialog = ({ open, onOk, onClose }: DeleteConnfirmDialogProps) => {
  const { t: tMessage } = useTranslationWithLang('message');
  const { t: tUserEditDelete } = useTranslationWithLang('userEditDelete');

  return (
    <Dialog open={open} disablePortal sx={{ zIndex: 5 }}>
      <DialogContent dividers>
        <Typography className="whitespace-pre-wrap">{tMessage('MU006F0210W')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          style={{ color: 'var(--c-textinput-label)' }}
          title={tUserEditDelete('TU006_025')}
        >
          {tUserEditDelete('TU006_025')}
        </Button>
        <Button
          onClick={() => onOk()}
          autoFocus
          style={{ color: 'var(--c-error)' }}
          title={tUserEditDelete('TU006_053')}
        >
          {tUserEditDelete('TU006_053')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
